import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom'; // Import Link for navigation
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import '../../styles/NewMainCarousel.css';

const FacilitiesCarousel = ({ currentIndex, setCurrentIndex }) => {
  const facilities = [
    { id: 1, name: 'Basketball Court', category: 'Sports', path: '/centers?type=sports',description: 'Victoria Sports Club offers versatile multi-purpose courts for basketball, volleyball, and other sports. Perfect for friendly matches, competitive games, or team training, our courts provide a safe and dynamic space for fitness, fun, and camaraderie.', image: '/vscimages/facilities/basket2.jpg' },
    { id: 2, name: 'Main Gym', category: 'Fitness', path: '/centers?type=fitness', description: 'Victoria Sports Club features modern equipment for strength, cardio, and functional training. Designed for all fitness levels, it provides a motivating space to stay active, improve performance, and achieve your health goals.', image: '/vscimages/facilities/newgym.jpg' },
    { id: 3, name: 'Water Spa', category: 'Wellness', path: '/centers?type=wellness', description: 'Victoria Sports Club offers a comprehensive wellness experience, featuring a lap pool, water spa, Jacuzzi, and steam and sauna rooms, all designed to promote fitness and relaxation in a vibrant environment.', image: '/vscimages/facilities/Water Spa.jpg' },
    { id: 3, name: 'VS Hotel', category: 'Lifestyle', path: '/centers?type=lifestyle', description: 'Victoria Sports Club offers luxurious accommodations and lifestyle amenities, featuring fine dining, a tranquil spa, and excellent fitness facilities for a rejuvenating experience.', image: '/vscimages/facilities/lifestyle.png' },
    { id: 4, name: 'MMA', category: 'Programs', path: '/centers?type=programs', description: 'Instructor-led classes and training programs designed to improve fitness, skills, and overall wellness.', image: '/vscimages/facilities/partner.png' },
  ];

  // const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => setCurrentIndex((prev) => (prev === facilities.length - 1 ? 0 : prev + 1));
  const handlePrev = () => setCurrentIndex((prev) => (prev === 0 ? facilities.length - 1 : prev - 1));

  const current = facilities[currentIndex];
  const nextItem1 = facilities[(currentIndex + 1) % facilities.length];
  const nextItem2 = facilities[(currentIndex + 2) % facilities.length];

  return (
    <div id="facilities-carousel" className="fac-section-container">
      <div className="fac-main-wrapper">
        
        {/* Left: Featured - Animates on key change */}
        <div className="fac-featured-area" key={`feat-container-${currentIndex}`}>
          <div className="fac-featured-card">
            <img src={current.image} alt={current.name} className="fac-featured-img" />
            <div className="fac-featured-overlay">
              <h3 className="fac-featured-title">{current.name}</h3>
            </div>
          </div>
        </div>

        {/* Center: Info - Text also fades in */}
        <div className="fac-info-area" key={`info-${currentIndex}`}>
          <div className="fac-badge">{current.category}</div>
          <p className="fac-description">{current.description}</p>
          <Link to={current.path} className="fac-view-btn">
            View More
          </Link>
          
          <div className="fac-nav-controls">
            <button className="fac-nav-btn" onClick={handlePrev}><FontAwesomeIcon icon={faChevronLeft} /></button>
            <button className="fac-nav-btn" onClick={handleNext}><FontAwesomeIcon icon={faChevronRight} /></button>
          </div>
        </div>

        {/* Right: Small Carousel - Slides in from right */}
        <div className="fac-carousel-area" key={`side-${currentIndex}`}>
          <div className="fac-horizontal-overflow">
            <div className="fac-peek-card">
              <div className="fac-small-img-wrap">
                <img src={nextItem1.image} alt={nextItem1.name} />
                <div className="fac-small-badge">{nextItem1.category}</div>
              </div>
              <p className="fac-small-desc">{nextItem1.description}</p>
            </div>
            
            <div className="fac-peek-card fac-mobile-hide">
              <div className="fac-small-img-wrap">
                <img src={nextItem2.image} alt={nextItem2.name} />
                <div className="fac-small-badge">{nextItem2.category}</div>
              </div>
              <p className="fac-small-desc">{nextItem2.description}</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default FacilitiesCarousel;